/* Kyvell · keeps the Shopify Inbox "Live chat" button clear of the main buttons (2026-10-30).
   The chat app and its settings are untouched: while a main button (Check out, payment icons, Shop CTA, Add to cart) would sit
   under the chat button, the chat button is raised just above it through the app's public CSS variable
   --shopify-chat-activator-offset. Nothing under it = the app's own position. The chat stays visible and clickable. */
(function () {
  /* main buttons + the subtotal row right above Check out (so the bubble rests in the free space above them) */
  var SEL = '[name="checkout"], .cart__dynamic-checkout-buttons, .payment-badges, .kh-btn, .product-form__submit, .sticky-atc__add_button, .totals, .cart-drawer__totals__row';
  var GAP = 10, raf = 0, base = null, cur = null;

  function parts() {
    var h = document.querySelector('shopify-chat');
    if (!h || !h.shadowRoot) return null;
    var rt = h.shadowRoot.querySelector('shopify-agent-runtime');
    var a = rt && rt.shadowRoot && rt.shadowRoot.querySelector('.activator');
    if (!a) return null;
    return { h: h, rt: rt, a: a };
  }

  function shown(el) {
    var d = el.closest('cart-drawer, .drawer');
    if (d && !d.classList.contains('active')) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height || r.bottom <= 0 || r.top >= window.innerHeight) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity !== 0 ? r : false;
  }

  function update() {
    raf = 0;
    var p = parts();
    if (!p || p.rt.hasAttribute('open') || p.h.hasAttribute('open')) return;
    if (base === null) {
      base = parseFloat(getComputedStyle(p.h).getPropertyValue('--shopify-chat-activator-offset')) || 20;
      cur = base;
    }
    var r = p.a.getBoundingClientRect();
    if (!r.width) return;
    var lift = cur - base;
    /* chat button at its own (app) position */
    var left = r.left - GAP, right = r.right + GAP, hgt = r.height;
    var homeBottom = r.bottom + lift, bottom = homeBottom;
    var ctas = [];
    document.querySelectorAll(SEL).forEach(function (el) { var b = shown(el); if (b && b.left < right && b.right > left) ctas.push(b); });
    for (var i = 0; i < 6; i++) {
      var hit = null;
      ctas.forEach(function (b) { if (b.bottom > bottom - hgt - GAP && b.top < bottom + GAP && (!hit || b.top < hit.top)) hit = b; });
      if (!hit) break;
      bottom = hit.top - GAP;
    }
    if (bottom < window.innerHeight * 0.3) bottom = window.innerHeight * 0.3;
    var next = Math.round(base + (homeBottom - bottom));
    if (next !== cur) {
      cur = next;
      if (next === base) p.h.style.removeProperty('--shopify-chat-activator-offset');
      else p.h.style.setProperty('--shopify-chat-activator-offset', next + 'px');
    }
  }

  function queue() { if (!raf) raf = requestAnimationFrame(update); }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('click', function () { setTimeout(queue, 350); setTimeout(queue, 900); }, true);
  setInterval(function () { if (!document.hidden) queue(); }, 500);
  queue();
})();
